import { defineComponent } from 'vue';
export default defineComponent({
    name: 'WdTableColumn',
    slots: ['title', 'filterIcon'],
    render() {
        return null;
    },
});
